import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import styles from './DeleteDialog.module.scss';

export type DeleteDialogProps = {
  onCancel: () => void;
  onSubmit: () => void;
  text: string;
  title: string;
  actionText?: string;
};

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
  onCancel,
  onSubmit,
  text,
  title,
  actionText = 'Yes, delete',
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    try {
      await onSubmit();
      setIsLoading(false);
      onCancel();
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      title={title}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="delete"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit}
          text={actionText}
          variant="danger"
          autoFocus
        />,
      ]}
    >
      <p className={styles['container']}>{text}</p>
    </Dialog>
  );
};
